import { Heading } from "@ariakit/react";
import { pluralize } from "../fmt.ts";
import { useModelContext } from "./ModelContext.tsx";
import { common, issuesInfo } from "./style.css.ts";

export function IssuesList() {
  const { issues, name } = useModelContext();

  if (issues.length === 0) {
    return null;
  }

  return (
    <div>
      <Heading className={common.sectionHeading}>Hold up!</Heading>

      <div className={issuesInfo.items}>
        {issues.map((issue) => {
          switch (issue.type) {
            case "WEAPONS_MAX_EXCEEDED": {
              const weaponsCount = pluralize(issue.current, {
                one: "one weapon",
                other: "# weapons",
              });

              return (
                <div key={issue.type}>
                  <span className={issuesInfo.type}>Too many weapons!</span>{" "}
                  {name} has {weaponsCount}, but maximum allowed is {issue.max}.
                </div>
              );
            }

            case "ANIMAL_HAS_ITEMS": {
              return (
                <div key={issue.type}>
                  <span className={issuesInfo.type}>Animal has items!</span>{" "}
                  Animals cannot be given weapons or fancy gear.
                </div>
              );
            }

            case "ITEMS_COST_LIMIT_EXCEEDED": {
              return (
                <div key={issue.type}>
                  <span className={issuesInfo.type}>
                    Spoiling the downtrodden!
                  </span>{" "}
                  {name} has weapons or gear that are worth more than{" "}
                  {pluralize(issue.max, { one: "1 cap", other: "# caps" })}.
                </div>
              );
            }

            default:
              return null;
          }
        })}
      </div>
    </div>
  );
}
